import { render } from "./Portifolio.vue?vue&type=template&id=52eb2528"
import script from "./Portifolio.vue?vue&type=script&lang=js"
export * from "./Portifolio.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__